import { consoleLogger } from '@shared/logging/consoleLogger';

export const getBaseDomain = (url: string) => {
  const baseDomainVerifierCookie = 'base_domain_verifier_cookie=cookie';
  const hostnameArray = url.split('.');
  /* Safari may incorrectly identify top-level domains like 'com' as valid base domains.
  To ensure accuracy, we require at least two domain parts (e.g., 'domain.com'). */
  if (hostnameArray.length > 1) {
    // eslint-disable-next-line no-useless-assignment
    let hostAggregate = hostnameArray[hostnameArray.length - 1];
    /* We read the cookie from the rightmost domain section, moving to the left until we can create the cookie */
    for (let i = hostnameArray.length - 2; i >= 0; i--) {
      hostAggregate = hostnameArray.slice(i).join('.');
      document.cookie = `${baseDomainVerifierCookie};domain=.${hostAggregate};`;
      /* We check if we successfully created a cookie - this means that it is a base domain */
      /* E.g. it won't work for co.uk, but will for domain.co.uk and never reaches subdomain.domain.co.uk */
      if (document.cookie.indexOf(baseDomainVerifierCookie) > -1) {
        /* We remove the verification cookie we created and return the host aggregate */
        document.cookie = `${
          baseDomainVerifierCookie.split('=')[0]
        }=;domain=.${hostAggregate};expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        return hostAggregate;
      }
    }
  }
  consoleLogger.logDebug(
    `Not able to get the base domain of the provided URL: ${url} relatively to the current host`,
  );
  /* We were not able to create the cookie for the given URL, returning it back without the protocol and utiq subdomain */
  return url
    .replace('https://utiq.', '')
    .replace('https://', '')
    .replace('https://utiq-test.', '');
};
